<!-- On vérifie que le rootForm existe avant de créer les champs liés -->
<div *ngIf="rootForm && lieuxTj && ! (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && lieuxTj">
    <div class="col" [formGroup]="rootForm">
      <div>
      <mat-accordion class=" col-12">
        <div *ngFor="let item of lieuxTj.controls; let i = index">
          <mat-expansion-panel (opened)="setStep(i)">
            <mat-expansion-panel-header>
              <mat-panel-description>
                <mat-icon>account_circle</mat-icon>&#xA0;
                <span [ngClass]="{'onglet-invalide': lieuxTj.controls[i].invalid}">
                  Informations sur le tribunal {{ i + 1 }}
                </span>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="form-row">
                <div class="col-md-8">
                    <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxTj.controls[i]" nbChoixVisiblePossible="10" label="aaLieuTjIelst" 
                        nomNomenclature="ielstTjTprx" [montreCode]="false" [enLectureSeule]="true">
                    </bis-filtered-select-input-keypad>
                 </div>
                 <div class="col-md-4">
                   <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxTj.controls[i]" 
                   infoBulle="Préciser dans le menu déroulant si le lieu de permanence est en quartier prioritaire" label="aaLieuTjQp" nomNomenclature="ouiNonNsp">
                   </bis-filtered-select-input-keypad>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxTj.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuTjNbPerm" [max]="999" infoBulle="1 demi-journée = 3h" [erreursCroisees]="['ctrlA62Tj']">
                   </bis-integer-inline-input-keypad>
                   <bis-affiche-erreurs-croisees [rootForm]="lieuxTj.controls[i]" colorErreur="danger"
                        labelErreur="ctrlA62Tj">
                   </bis-affiche-erreurs-croisees>
                 </div>
            </div>
            <div class="form-row">
                 <div class="col-md-1"></div>
                 <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxTj.controls[i]" classeColLabel="col-8" classeColInput="col-2" 
                    classeSupplInput="text-right" label="aaLieuTjNbPermEtp" [max]="9999" [erreursCroisees]="['ctrlA63Tj']"
                    infoBulle="3 personnes présentes sur une demi-journée = 3 demi-journées travaillées">
                    </bis-integer-inline-input-keypad>
                    <bis-affiche-erreurs-croisees [rootForm]="lieuxTj.controls[i]" colorErreur="danger"
                        labelErreur="ctrlA63Tj">
                   </bis-affiche-erreurs-croisees>
                   <bis-affiche-alertes [labelAlerte]="'alertA41Tj_' + i"></bis-affiche-alertes>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxTj.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuTjNbVict" [max]="99999" infoBulle="(physiques et morales)">
                   </bis-integer-inline-input-keypad>
                </div>
           </div>
        </mat-expansion-panel>
        </div>
        </mat-accordion>
        <div class="form-row">
            <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuTjNb" [max]="99" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4"      
                infoBulle="Cette zone est calculée automatiquement à partir du nombre de tribunal ajouté(s)">
              </bis-integer-inline-input>
          </div>
          <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuTjNbPermTot" [max]="9999" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuTjNbPermEtpTot" [max]="99999" 
                enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuTjNbVictTot" [max]="999999" 
                  enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>  
      </div>
    </div>
  </div>
</div>


<div *ngIf="rootForm && lieuxTj && (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && lieuxTj">
    <div class="col" [formGroup]="rootForm">
      <div>
        <div *ngFor="let item of lieuxTj.controls; let i = index">
            <div class="form-row">
                <div class="col-md-8">
                    <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxTj.controls[i]" nbChoixVisiblePossible="10" label="aaLieuTjIelst" 
                        nomNomenclature="ielstTjTprx" [montreCode]="false" [enLectureSeule]="true">
                    </bis-filtered-select-input-keypad>
                 </div>
                 <div class="col-md-4">
                   <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxTj.controls[i]" 
                   infoBulle="Préciser dans le menu déroulant si le lieu de permanence est en quartier prioritaire" label="aaLieuTjQp" nomNomenclature="ouiNonNsp">
                   </bis-filtered-select-input-keypad>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxTj.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuTjNbPerm" [max]="999" infoBulle="1 demi-journée = 3h" [erreursCroisees]="['ctrlA62Tj']">
                   </bis-integer-inline-input-keypad>
                   <bis-affiche-erreurs-croisees [rootForm]="lieuxTj.controls[i]" colorErreur="danger"
                        labelErreur="ctrlA62Tj">
                   </bis-affiche-erreurs-croisees>
                 </div>
            </div>
            <div class="form-row">
                 <div class="col-md-1"></div>
                 <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxTj.controls[i]" classeColLabel="col-8" classeColInput="col-2" 
                    classeSupplInput="text-right" label="aaLieuTjNbPermEtp" [max]="9999" [erreursCroisees]="['ctrlA63Tj']"
                    infoBulle="3 personnes présentes sur une demi-journée = 3 demi-journées travaillées">
                    </bis-integer-inline-input-keypad>
                    <bis-affiche-erreurs-croisees [rootForm]="lieuxTj.controls[i]" colorErreur="danger"
                        labelErreur="ctrlA63Tj">
                   </bis-affiche-erreurs-croisees>
                   <bis-affiche-alertes [labelAlerte]="'alertA41Tj_' + i"></bis-affiche-alertes>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxTj.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuTjNbVict" [max]="99999" infoBulle="(physiques et morales)">
                   </bis-integer-inline-input-keypad>
                </div>
           </div>
        </div>
        <div class="form-row mt-4">
            <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuTjNb" [max]="99" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4"      
                infoBulle="Cette zone est calculée automatiquement à partir du nombre de tribunal ajouté(s)">
              </bis-integer-inline-input>
          </div>
          <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuTjNbPermTot" [max]="9999" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuTjNbPermEtpTot" [max]="99999" 
                enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuTjNbVictTot" [max]="999999" 
                  enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>  
      </div>
    </div>
  </div>
</div>
